import { render, staticRenderFns } from "./TopNavComponent.vue?vue&type=template&id=2bb552ed&"
import script from "./TopNavComponent.vue?vue&type=script&lang=js&"
export * from "./TopNavComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports